
/* injects from baggage-loader */

'use strict';

import ProductCreatorServiceUpdatesComponent from './product-creator.service-updates.component';

const ProductCreatorServiceUpdatesPageModule = angular.module('product-creator-service-updates-module', [
    'ui.router'
  ])
  .config(($stateProvider, $urlRouterProvider) => {
    'ngInject';

    $urlRouterProvider.otherwise('/');

    $stateProvider
      .state('product-creator.service-updates', {
        url: '/service-updates',
        component: 'productCreatorServiceUpdates',
        // Resolve promises into controller bindings, see component for bindings
        // resolve: { }
      });
  })
  .component('productCreatorServiceUpdates', new ProductCreatorServiceUpdatesComponent());

export default ProductCreatorServiceUpdatesPageModule;



// WEBPACK FOOTER //
// ./src/app/pages/product-creator/service-updates/product-creator.service-updates.module.js